// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.HelpCenter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.HelpCenter = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var HelpCenter = _exports.HelpCenter = function HelpCenter(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      opacity: "0.4",
      d: "M8.00065 14.6673C11.6825 14.6673 14.6673 11.6825 14.6673 8.00065C14.6673 4.31875 11.6825 1.33398 8.00065 1.33398C4.31875 1.33398 1.33398 4.31875 1.33398 8.00065C1.33398 11.6825 4.31875 14.6673 8.00065 14.6673Z",
      fill: "#313137"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M8.00033 9.24988C7.94766 9.24988 7.8943 9.24184 7.84163 9.22384C7.57963 9.13584 7.43903 8.85254 7.52637 8.59054C7.64703 8.23054 7.95972 7.8912 8.51172 7.5212C9.19239 7.0652 9.105 6.56525 9.07633 6.40125C9.001 5.96525 8.63364 5.59395 8.20231 5.51795C7.87431 5.45795 7.55373 5.54395 7.30306 5.75395C7.05106 5.96528 6.90625 6.27647 6.90625 6.60714C6.90625 6.88314 6.68225 7.10714 6.40625 7.10714C6.13025 7.10714 5.90625 6.88314 5.90625 6.60714C5.90625 5.97981 6.18099 5.38984 6.66032 4.98784C7.13499 4.5905 7.75964 4.42456 8.3763 4.5339C9.22097 4.68323 9.9137 5.38118 10.061 6.23051C10.207 7.07118 9.85436 7.82525 9.06836 8.35258C8.58103 8.67925 8.4903 8.86122 8.47363 8.90922C8.40363 9.11789 8.20899 9.24988 8.00033 9.24988ZM8.68034 10.9999C8.68034 10.6319 8.38234 10.3332 8.01367 10.3332H8.007C7.639 10.3332 7.34359 10.6319 7.34359 10.9999C7.34359 11.3679 7.64567 11.6665 8.01367 11.6665C8.38167 11.6665 8.68034 11.3679 8.68034 10.9999Z",
      fill: "#313137"
    }));
  };
});
